import React, { useRef, useEffect } from 'react';

interface CludoCommentProps {
	before?: string;
	after?: string;
	children: React.ReactNode;
	className?: string;
}

export const CludoComment = ({ before = 'cludooff: index', after = 'cludoon: index', children, className }: CludoCommentProps) => {
	const wrapperRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const el = wrapperRef.current;
		if (!el || !el.parentNode) return;

		const beforeComment = document.createComment(before);
		const afterComment = document.createComment(after);

		el.parentNode.insertBefore(beforeComment, el);
		if (el.nextSibling) {
			el.parentNode.insertBefore(afterComment, el.nextSibling);
		} else {
			el.parentNode.appendChild(afterComment);
		}

		return () => {
			if (beforeComment.parentNode) beforeComment.parentNode.removeChild(beforeComment);
			if (afterComment.parentNode) afterComment.parentNode.removeChild(afterComment);
		};
	}, [before, after]);

	return (
		<div ref={wrapperRef} className={className}>
			{children}
		</div>
	);
};
